<template>
  <div class="authorize">
    <p v-if="!isWX">请在微信浏览器打开</p>
    <van-loading v-else type="spinner" color="#1989fa" />
  </div>
</template>

<script>
import {weChatGetTicked, weChatSendCode} from '@/api/index'
import wx from 'weixin-js-sdk'
import {serializeUrl} from '@/utils/utils'
import {mapState} from 'vuex'

export default {
  name: 'WechatAuth',
  data() {
    return {
      isWX: true
    }
  },
  computed: {
    ...mapState({
      tokenInfo: "tokenInfo",
    }),
  },
  mounted() {
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') === -1) {
      this.isWX = false
      return
    }
    let code = serializeUrl().param.code
    if (code) {
      this.getCode(code)
    } else {
      this.authorize()
    }
  },
  methods: {
    authorize() {
      const redirect_uri = window.location.href
      weChatGetTicked({url: redirect_uri}).then(res => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: `${res.noncestr}`,
          signature: res.signature,
          jsApiList: ['chooseWXPay','scanQRCode','checkJsApi']
        })
        const appId = res.appId
        wx.ready(res => {
          wx.checkJsApi({/*检查微信支付是否验证通过*/
            jsApiList: ['chooseWXPay'],
            success: res => {
              console.log('checked api:', res)
            },
            fail: err => {
              console.log('check api fail:', err)
            }
          })
          wx.checkJsApi({/*检查微信扫码是否验证通过*/
            jsApiList: ['scanQRCode'],
            success: res => {
              console.log('checked scanQRCode:', res)
            },
            fail: err => {
              console.log('check scanQRCode fail:', err)
            }
          })
          let url = encodeURIComponent(redirect_uri)
          let urls = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appId+'&redirect_uri='+url+'&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
          // 微信基本授权
          window.location = urls
        })
      })
    },
    getCode(code) {
      weChatSendCode({
        code:code
      }).then(res=>{
        if (res.result) {
          const info = {...this.tokenInfo}
          info.wechatAuth = true
          info.openId = res.openId
          this.$store.dispatch('saveToken', {})
          localStorage.removeItem('loginInfo')

          localStorage.setItem('loginInfo', JSON.stringify(info))
          //存储登录信息
          this.$store.dispatch('saveToken', {
            ...info,
          })
          window.location = location.protocol + '//' + location.host + location.pathname
        } else {
          const redirect_uri = window.location.href
          let url = encodeURIComponent(redirect_uri)
          let urls = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+res.appId+'&redirect_uri='+url+'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
          // 微信授权 需要用户同意
          window.location = urls
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.authorize{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgb(251, 251, 251);
  font-size: 32px;
  text-align: center;
  color: #999;
}
</style>
